// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  /* Brand */
  --primary: #9d1f5f;
  --primary-light: #b8316f;
  --primary-dark: #7a1847;
  --secondary: #2e8b57;
  --secondary-light: #3fa670;
  --secondary-dark: #1f6b42;
  --accent: #155c6b;
  --accent-700: #155c6b;
  --accent-600: #1c6e80;

  /* Semantic */
  --success: #4caf50;
  --warning: #ff9800;
  --error: #f44336;
  --info: #2196f3;
  --amber: #ffc107;
  --link: #0069d9;

  /* Neutrals */
  --gray-50: #fafafa;
  --gray-100: #f5f5f5;
  --gray-200: #eeeeee;
  --gray-300: #e0e0e0;
  --gray-400: #bdbdbd;
  --gray-500: #9e9e9e;
  --gray-600: #757575;
  --gray-700: #616161;
  --gray-800: #424242;
  --gray-900: #212121;

  /* Surfaces */
  --bg: #ffffff;
  --bg-secondary: #f5f5f5;
  --bg-tertiary: #fafafa;
  --surface-brand-wash: #fcf6f9;
  --surface-selected: #efbfd1;
  --surface-selected-soft: #f8e2eb;
  --surface-success: #e2f1e9;
  --surface-info: #dcedf1;
  --surface-warning: #fff3e0;
  --surface-error: #fdecea;

  /* Text */
  --text-primary: #212121;
  --text-secondary: #6b6b6b;
  --text-placeholder: #767676;
  --text-disabled: #bdbdbd;
  --text-on-primary: #ffffff;

  /* Borders */
  --border: #e0e0e0;
  --border-light: #f5f5f5;
  --border-dark: #bdbdbd;

  /* Focus */
  --focus-ring: 0 0 0 3px rgba(157, 31, 95, 0.28);

  /* Legacy (older stylesheets) */
  --color-main: var(--primary);
  --color-main-hover: var(--primary-light);
  --color-main-dark: var(--primary-dark);
  --color-pink-muted: var(--surface-selected);

  --color-white: #ffffff;
  --color-black: #000000;
  --color-gray-light: var(--gray-100);
  --color-gray-border: var(--border);
  --color-gray-bg: var(--gray-50);
  --color-gray-text: var(--text-secondary);
  --color-text-dark: var(--text-primary);
  --color-text-muted: var(--text-secondary);
  --color-text: var(--text-primary);

  --color-accent-blue: var(--accent);
  --color-accent-purple: var(--surface-selected);

  --color-link: var(--link);
  --color-link-hover: var(--primary);
  --color-link-visited: var(--primary-dark);
  --color-link-focus-ring: rgba(157, 31, 95, 0.35);

  --color-error: var(--error);
  --color-error-bg: var(--surface-error);
  --color-success: var(--success);
  --color-success-bg: var(--surface-success);
}
`, "",{"version":3,"sources":["webpack://./src/colors.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,kBAAkB;EAClB,wBAAwB;EACxB,uBAAuB;EACvB,oBAAoB;EACpB,0BAA0B;EAC1B,yBAAyB;EACzB,iBAAiB;EACjB,qBAAqB;EACrB,qBAAqB;;EAErB,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,eAAe;;EAEf,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;;EAEnB,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,6BAA6B;EAC7B,2BAA2B;EAC3B,gCAAgC;EAChC,0BAA0B;EAC1B,uBAAuB;EACvB,0BAA0B;EAC1B,wBAAwB;;EAExB,SAAS;EACT,uBAAuB;EACvB,yBAAyB;EACzB,2BAA2B;EAC3B,wBAAwB;EACxB,0BAA0B;;EAE1B,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;EACvB,sBAAsB;;EAEtB,UAAU;EACV,+CAA+C;;EAE/C,+BAA+B;EAC/B,4BAA4B;EAC5B,wCAAwC;EACxC,sCAAsC;EACtC,2CAA2C;;EAE3C,sBAAsB;EACtB,sBAAsB;EACtB,mCAAmC;EACnC,kCAAkC;EAClC,+BAA+B;EAC/B,wCAAwC;EACxC,sCAAsC;EACtC,yCAAyC;EACzC,iCAAiC;;EAEjC,kCAAkC;EAClC,8CAA8C;;EAE9C,yBAAyB;EACzB,kCAAkC;EAClC,yCAAyC;EACzC,gDAAgD;;EAEhD,2BAA2B;EAC3B,sCAAsC;EACtC,+BAA+B;EAC/B,0CAA0C;AAC5C","sourcesContent":[":root {\n  /* Brand */\n  --primary: #9d1f5f;\n  --primary-light: #b8316f;\n  --primary-dark: #7a1847;\n  --secondary: #2e8b57;\n  --secondary-light: #3fa670;\n  --secondary-dark: #1f6b42;\n  --accent: #155c6b;\n  --accent-700: #155c6b;\n  --accent-600: #1c6e80;\n\n  /* Semantic */\n  --success: #4caf50;\n  --warning: #ff9800;\n  --error: #f44336;\n  --info: #2196f3;\n  --amber: #ffc107;\n  --link: #0069d9;\n\n  /* Neutrals */\n  --gray-50: #fafafa;\n  --gray-100: #f5f5f5;\n  --gray-200: #eeeeee;\n  --gray-300: #e0e0e0;\n  --gray-400: #bdbdbd;\n  --gray-500: #9e9e9e;\n  --gray-600: #757575;\n  --gray-700: #616161;\n  --gray-800: #424242;\n  --gray-900: #212121;\n\n  /* Surfaces */\n  --bg: #ffffff;\n  --bg-secondary: #f5f5f5;\n  --bg-tertiary: #fafafa;\n  --surface-brand-wash: #fcf6f9;\n  --surface-selected: #efbfd1;\n  --surface-selected-soft: #f8e2eb;\n  --surface-success: #e2f1e9;\n  --surface-info: #dcedf1;\n  --surface-warning: #fff3e0;\n  --surface-error: #fdecea;\n\n  /* Text */\n  --text-primary: #212121;\n  --text-secondary: #6b6b6b;\n  --text-placeholder: #767676;\n  --text-disabled: #bdbdbd;\n  --text-on-primary: #ffffff;\n\n  /* Borders */\n  --border: #e0e0e0;\n  --border-light: #f5f5f5;\n  --border-dark: #bdbdbd;\n\n  /* Focus */\n  --focus-ring: 0 0 0 3px rgba(157, 31, 95, 0.28);\n\n  /* Legacy (older stylesheets) */\n  --color-main: var(--primary);\n  --color-main-hover: var(--primary-light);\n  --color-main-dark: var(--primary-dark);\n  --color-pink-muted: var(--surface-selected);\n\n  --color-white: #ffffff;\n  --color-black: #000000;\n  --color-gray-light: var(--gray-100);\n  --color-gray-border: var(--border);\n  --color-gray-bg: var(--gray-50);\n  --color-gray-text: var(--text-secondary);\n  --color-text-dark: var(--text-primary);\n  --color-text-muted: var(--text-secondary);\n  --color-text: var(--text-primary);\n\n  --color-accent-blue: var(--accent);\n  --color-accent-purple: var(--surface-selected);\n\n  --color-link: var(--link);\n  --color-link-hover: var(--primary);\n  --color-link-visited: var(--primary-dark);\n  --color-link-focus-ring: rgba(157, 31, 95, 0.35);\n\n  --color-error: var(--error);\n  --color-error-bg: var(--surface-error);\n  --color-success: var(--success);\n  --color-success-bg: var(--surface-success);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
